<template>
    <grid ref="grid" :columnDefs="columnDefs" :fetchCallback="fetchCallback">
        <div class="travel-insurance-issuances__toolbar">
             <date-range-picker
                :range-options="predefinedRanges"
                :value="dateRange"
                :date-format="userUnicodeDateFormat"
                @input="onInputChange"
            ></date-range-picker>
              <b-button-group aria-label="Export table data">
            <responsive-button
                    :icon="['fas', 'file-excel']"
                    :href="exportExcelHref"
                    @click="generatingExcelReportSuccessToast"
                    variant="primary"
                    ></responsive-button
                >
            </b-button-group>
            <responsive-button
                :icon="['fas', 'arrows-rotate']"
                @click="refresh"
                variant="primary"
                >Refresh</responsive-button
            >   
        </div>
    </grid>
</template>

<script>
    import format from 'date-fns/format';
    import DateRangePicker, {
        nameToRange,
        THIS_MONTH,
        ALL_DATES,
        LAST_MONTH,
        LAST_YEAR,
        THIS_YEAR,
        TODAY,
        YESTERDAY,
    } from '../../generic/date-range-picker/date-range-picker.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import Grid from '../../generic/grid/grid.vue';
    import { mapGetters } from 'vuex';
    import API from './../../../api';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';

    export default {
        name: 'TravelInsuranceIssuances',
        components: {
            DateRangePicker,
            ResponsiveButton,
            Grid,
        },
        mixins: [removeScrollMixin],
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            ...mapGetters('travelInsurance', ['travelInsuranceStatus']),
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;

                    return API.get(
                        encodeURI(
                            `/app/travel-insurance/issuances-list/?start_date=${format(
                                this.dateRange.from,
                                this.dateRequestFormat
                            )}&end_date=${format(
                                this.dateRange.to,
                                this.dateRequestFormat
                            )}&offset=${offset}&limit=${limit}&sort=${sort}&desc=${desc}&search=${search}`
                        )
                    ).then((response) => ({
                        data: this.mapResponse(response.data),
                    }));
                };
            },
            rowData() {
                return this.mapResponse(this.travelInsurances);
            },
            exportExcelHref() {
                return `/app/travel-insurance/issuances-list/excel/?start_date=${format(
                    this.dateRange.from,
                    this.dateRequestFormat
                )}&end_date=${format(
                    this.dateRange.to,
                    this.dateRequestFormat
                )}&offset=${this.offset}&limit=${this.limit}&sort=${
                    this.sort
                }&desc=${this.desc}&search=${this.search}`;
            },
        },
        data() {
            const dateRange = nameToRange(THIS_MONTH);

            return {
                offset: 0,
                limit: 20,
                sort: 'created',
                desc: false,
                search: '',
                dateRequestFormat: 'yyyy-MM-dd',
                dateRange,
                predefinedRanges: [
                    TODAY,
                    YESTERDAY,
                    THIS_MONTH,
                    LAST_MONTH,
                    THIS_YEAR,
                    LAST_YEAR,
                    ALL_DATES,
                ],
                busy: false,
                columnDefs: [
                    {
                        field: 'created',
                        headerName: 'Created',
                        sort: 'desc',
                    },
                    {
                        field: 'invoice_number',
                        headerName: 'Invoice #',
                        cellRenderer: ({ data, value }) =>
                            value
                                ? `<a href="${value.invoice_link}">${value.invoice_number}</a>`
                                : 'No file',
                    },
                    {
                        field: 'properties',
                        headerName: 'Property',
                        flex: 2,
                    },
                    {
                        field: 'insurance_id',
                        headerName: 'Policy ID',
                        flex: 0,
                    },
                    {
                        field: 'full_name',
                        headerName: 'Guest Name',
                        flex: 2,
                    },
                    {
                        field: 'from_date',
                        headerName: 'Check In',
                        flex: 0,
                    },
                    {
                        field: 'to_date',
                        headerName: 'Check Out',
                        flex: 0,
                    },
                    {
                        field: 'cost',
                        headerName: 'Cost (USD)',
                        flex: 0,
                    },
                ],
            };
        },
        methods: {
            mapResponse(response) {
                return response.map((insurance) => {
                    return {
                        id: insurance.id,
                        created: insurance.created,
                        invoice_number: {
                            invoice_link: insurance.invoice_link,
                            invoice_number: insurance.invoice_number,
                        },
                        properties: insurance.properties,
                        insurance_id: insurance.insurance_id,
                        full_name: insurance.full_name,
                        from_date: insurance.meta_res.from_date,
                        to_date: insurance.meta_res.to_date,
                        cost: insurance.cost,
                    };
                });
            },
            onInputChange(value) {
                this.dateRange = { ...value };
                this.refresh();
            },
            refresh() {
                this.$refs.grid.refreshDataSource();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .travel-insurance-issuances {
        &__toolbar {
            display: flex;
        }
    }
</style>
